<template>
  <card-seplag titulo="Cadastro da Declaração de Bens" class="">
    <div class="declaracaoBensContainer">
      <div class="p-col-12">
        <!--              
                <div style="text-align:center;margin:1.3rem auto">
                    <h4 >Texto orientativo que o cliente vai enviar Texto orientativo que o cliente vai enviar Texto orientativo que o cliente vai enviar Texto orientativo que o cliente vai enviar </h4>
                </div> -->

        <div class="font-style">
          <label
            style="font-size: 1.3rem; font-weight: 600; margin-bottom: 1rem"
            >Selecione o Tipo de Declaração</label
          >
          <p>
            Selecione o tipo da Declaração, clicando em uma das opções abaixo:
          </p>
          <div style="text-align: center">
            <button
              class="btn-npb-white button buttonSelected"
              v-if="
                registro &&
                registro.tipoDeclaracao &&
                registro.tipoDeclaracao == 'BRANCO'
              "
              @click="naoPossuiBens()"
              :disabled="!isPermitir"
            >
              <span> Não Possui Bens</span>
            </button>
            <button
              class="btn-npb-black button"
              v-else-if="
                parmForm.tipoDeclaracao == 'BRANCO' ||
                parmForm.tipoDeclaracao == 'NAO_INFORMADO'
              "
              @click="naoPossuiBens()"
              :disabled="
                (isPermitir && parmForm.tipoDeclaracao == 'BRANCO') ||
                (isPermitir && parmForm.tipoDeclaracao == 'NAO_INFORMADO')
                  ? false
                  : true
              "
            >
              Não Possui Bens
            </button>
            <button
              class="btn-npb-black button"
              v-else
              @click="displayInformativo = true"
              :disabled="
                (isPermitir && parmForm.tipoDeclaracao == 'BRANCO') ||
                (isPermitir && parmForm.tipoDeclaracao != 'NAO_INFORMADO')
                  ? false
                  : true
              "
            >
              Não Possui Bens
            </button>

            <button
              class="btn-fc-white button buttonSelected"
              v-if="
                registro &&
                registro.tipoDeclaracao &&
                registro.tipoDeclaracao == 'FORMULARIO'
              "
              :disabled="!isPermitir"
            >
              <span> Formulário de Cadastro </span>
            </button>
            <button
              class="btn-fc-black button"
              v-else-if="
                !parmForm.tipoDeclaracao == 'FORMULARIO' ||
                parmForm.tipoDeclaracao == 'NAO_INFORMADO'
              "
              @click="declaracaoForm()"
              :disabled="
                (isPermitir && !parmForm.tipoDeclaracao == 'FORMULARIO') ||
                (isPermitir && parmForm.tipoDeclaracao == 'NAO_INFORMADO')
                  ? false
                  : true
              "
            >
              <span> Formulário de Cadastro </span>
            </button>
            <button
              class="btn-fc-black button"
              v-else
              @click="displayInformativo = true"
              :disabled="
                (isPermitir && !parmForm.tipoDeclaracao == 'FORMULARIO') ||
                (isPermitir && parmForm.tipoDeclaracao != 'NAO_INFORMADO')
                  ? false
                  : true
              "
            >
              <span> Formulário de Cadastro </span>
            </button>

            <button
              class="btn-ir-white button buttonSelected"
              v-if="
                registro &&
                registro.tipoDeclaracao &&
                registro.tipoDeclaracao == 'ARQUIVO'
              "
              :disabled="!isPermitir"
            >
              <span> Imposto de Renda </span>
            </button>
            <button
              class="btn-ir-black button"
              v-else-if="
                (isPermitir && !parmForm.tipoDeclaracao == 'ARQUIVO') ||
                (isPermitir && parmForm.tipoDeclaracao == 'NAO_INFORMADO')
              "
              @click="declaracaoArqFederal()"
              :disabled="
                !parmForm.tipoDeclaracao == 'ARQUIVO' ||
                parmForm.tipoDeclaracao == 'NAO_INFORMADO'
                  ? false
                  : true
              "
            >
              <span> Imposto de Renda </span>
            </button>
            <button
              class="btn-ir-black button"
              v-else
              @click="displayInformativo = true"
              :disabled="
                (isPermitir && !parmForm.tipoDeclaracao == 'ARQUIVO') ||
                (isPermitir && parmForm.tipoDeclaracao != 'NAO_INFORMADO')
                  ? false
                  : true
              "
            >
              <span> Imposto de Renda </span>
            </button>
          </div>
        </div>
      </div>

      <div class="p-col 12 p-md-12 nao-possui-bens-container">
        <card-seplag
          class="p-col 12"
          v-if="
            registro &&
            registro.tipoDeclaracao &&
            registro.tipoDeclaracao == 'BRANCO'
          "
        >
          <span style="color: red"
            >Caso realmente não possua bens a declarar, marque a opção e
            finalize a declaração.</span
          >
          <div class="p-col-10 avisos">
            <Checkbox id="binary" v-model="checked" :binary="true" />
            <p><strong>DECLARO que não possuo Bens a Declarar.</strong></p>
          </div>
          <div class="p-col p-md-6">
            <div class="p-grid" style="justify-content: center;">
              <div class="p-col-12 p-md-6">
                <Button
                  label="Finalizar Declaração"
                  class="p-button-raised p-button-rounded p-button-success"
                  @click="abreDialogo()"
                  :disabled="!isPermitir"
                />
              </div>

              <div class="p-col-12 p-md-6"  v-if="permiteExecutarAcao">
                <Button
                  class="p-button-raised p-button-rounded p-button-danger"
                  label="Excluir Declaração"
                  @click="abreDialogoExclusao()"
                  :disabled="!isPermitir"
                ></Button>
              </div>
            </div>
          </div>

          <Dialog
            :header="'Confirmação de Envio'"
            :visible.sync="dialogConfirmacao"
            class="dialogo-termo-aceite"
            :contentStyle="{ width: '30vw' }"
            :modal="true"
          >
            <div class="confirmation-content texto-centro">
              <span
                >Você tem certeza que gostaria de finalizar esta
                declaração?</span
              >
            </div>
            <template #footer>
              <Button
                label="Não"
                icon="pi pi-times"
                @click="fecharDialogo"
                class="p-button-text"
              />
              <Button
                label="Sim"
                icon="pi pi-check"
                @click="salvarDeclaracao"
                class="p-button-text"
              />
            </template>
          </Dialog>
          <Dialog
            :header="'Confirmação de Exclusão'"
            :visible.sync="dialogConfirmacaoExclusao"
            class="dialogo-termo-aceite"
            :contentStyle="{ width: '30vw' }"
            :modal="true"
          >
            <div class="confirmation-content texto-centro">
              <span>
                Você tem certeza que deseja EXCLUIR essa declaração? Obs: O
                Protocolo atual será excluído, você terá que realizar uma nova
                declaração para gerar um novo Protocolo.</span
              >
            </div>
            <template #footer>
              <Button
                label="Não"
                icon="pi pi-times"
                @click="fecharDialogoExclusao"
                class="p-button-text"
              />
              <Button
                label="Sim"
                icon="pi pi-check"
                @click="excluirDeclaracao"
                class="p-button-text"
                autofocus
                :disabled="!isPermitir"
              />
            </template>
          </Dialog>
        </card-seplag>
      </div>

      <DeclaracaoFormulario
        v-if="
          registro &&
          registro.tipoDeclaracao &&
          registro.tipoDeclaracao == 'FORMULARIO'
        "
        :mode="mode"
        :pFormData="parmForm"
        :isPermitirEditar="isPermitir"
        @atualizaParmForm="atualizaParmForm"
        @protocolo="protocolo"
      />

      <DeclaracaoArqFederal
        v-if="
          registro &&
          registro.tipoDeclaracao &&
          registro.tipoDeclaracao == 'ARQUIVO'
        "
        :mode="mode"
        :pFormData="parmForm"
        :isPermitirEditar="isPermitir"
        @protocolo="protocolo"
        @atualizarParmArq="atualizarParmArq"
      />
    </div>

    <Dialog
      header="Protocolo"
      :visible.sync="displayModal"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="dialog-protocolo">
        <i class="pi pi-check" style="font-size: 6rem; color: green"></i>
        <h2>{{ TextoFinalizacao }}</h2>
      </div>
      <template #footer>
        <Button
          label="Fechar"
          class="p-button-text"
          icon="pi pi-check"
          @click="closeModal"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      header="Informativo"
      :visible.sync="displayInformativo"
      :containerStyle="{ width: '50vw' }"
      :modal="true"
    >
      <div class="dialog-protocolo">
        <h2>Para mudar o tipo de declaração, exclua a declaração atual.</h2>
      </div>
      <template #footer>
        <Button
          label="OK"
          class="p-button-text"
          icon="pi pi-check"
          @click="displayInformativo = false"
          autofocus
        />
      </template>
    </Dialog>
    
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import DeclaracaoArqFederal from "./declaracaoArqFederal.vue";
import DeclaracaoFormulario from "./declaracaoFormulario";
import { baseApiUrl, printToast } from "@/config/global";

const getDeclaracaoBens = () => {
  return {
    tipoDeclaracao: null,
  };
};
export default {
  name: "formDeclaracaoBens",
  components: { CardSeplag, DeclaracaoArqFederal, DeclaracaoFormulario },
  data: function () {
    return {
      registro: getDeclaracaoBens(),
      dialogConfirmacao: false,
      dialogConfirmacaoExclusao: false,
      paginaAtual: null,
      checked: false,
      mode: "INS", // Possiveis valores -> INS:inserir ; UPD: Alterar ; DLP:Visualizar ; DEL:Deletar
      idenPessoaExercicio: 0,
      parmForm: {},
      displayModal: false,
      displayInformativo: false,
      numProcotolo: 0,
      idenContaAcesso: 0,
      TextoFinalizacao: "",
      isPermitir: false,
      permiteExecutarAcao: false,
    };
  },
  methods: {
    carregarDados() {
      this.idenContaAcesso = this.$store.getters.getUser.contaAcesso.id;
      if (this.$route.params.id) {
        this.idenPessoaExercicio = this.$route.params.id;
        this.mode = "UPD";

        this.$http
          .get(
            `${baseApiUrl}/pessoaexercicios/resumo/${this.idenPessoaExercicio}`
          )
          .then((res) => {
            this.parmForm = res.data;
            this.registro.tipoDeclaracao = res.data.tipoDeclaracao;            
            this.permiteExecutarAcao = res.data.tipoDeclaracao != "NAO_INFORMADO",
            this.checked =
              (this.parmForm.statDeclaracao == "ENVIADA" &&
                this.parmForm.tipoDeclaracao == "BRANCO") ||
              (this.parmForm.statDeclaracao == "FINALIZADA" &&
                this.parmForm.tipoDeclaracao == "BRANCO") ||
              (this.parmForm.statDeclaracao == "FINALIZADA_ALTERADA" &&
                this.parmForm.tipoDeclaracao == "BRANCO")||
              (this.parmForm.statDeclaracao == "ESCOLHA_TIPO_DECLARACAO" &&
                this.parmForm.tipoDeclaracao == "BRANCO");
            this.isPermitiEditar(res.data);
            this.parmForm.bens = this.parmForm.bens.map((item) => {
              if (item.flagTitularDependenteDesc) {
                return item;
              } else {
                return {
                  ...item,
                  flagTitularDependenteDesc:
                    item.flagTitularDependente == "T"
                      ? "Titular"
                      : "Dependente",
                };
              }
            });

            this.parmForm.arquivosDeclaracao =
              this.parmForm.arquivosDeclaracao.filter(
                (item) => item.arquivo.statArquivo != "INATIVO"
              );
          });
      } else {
        this.$router.push({ path: `/${process.env.VUE_APP_BASE_URL}` });
      }
    },

    fecharDialogo() {
      this.dialogConfirmacao = false;
    },

    fecharDialogoExclusao() {
      this.dialogConfirmacaoExclusao = false;
    },

    abreDialogoExclusao() {
      this.dialogConfirmacaoExclusao = true;
    },

    abreDialogo() {
      if (this.checked) {
        this.dialogConfirmacao = true;
      } else {
        printToast({
          severity: "error",
          summary: "Termo de Aceite",
          detail: "É necessário marcar que não possui bens a serem declarados",
        });
      }
    },

    salvarDeclaracao() {
      if (this.isPermitir) {
        this.$http
          .put(
            `${baseApiUrl}/pessoaexercicios/finalizar/branco/${this.idenPessoaExercicio}/${this.idenContaAcesso}`
          )
          .then((res) => {
            this.dialogConfirmacao = false;
            this.protocolo({ data: res.data });
          });
      }
    },
    atualizaParmForm(event) {
      this.$http
        .get(
          `${baseApiUrl}/pessoaexercicios/resumo/${this.idenPessoaExercicio}`
        )
        .then((res) => {
          this.parmForm = res.data;
          event.component.formData = this.parmForm;
          event.component.permiteExecutarAcao =
            this.parmForm.tipoDeclaracao != "NAO_INFORMADO" ||
            this.parmForm.bens.length > 0;
          event.component.tabelaBens = this.parmForm.bens
            .filter((item) => item.statBemPessoa != "INATIVO")
            .map((item) => {
              if (item.flagTitularDependenteDesc) {
                return item;
              } else {
                return {
                  ...item,
                  flagTitularDependenteDesc:
                    item.flagTitularDependente == "T"
                      ? "Titular"
                      : "Dependente",
                };
              }
            });
          this.parmForm.arquivosDeclaracao =
            this.parmForm.arquivosDeclaracao.filter(
              (item) => item.arquivo.statArquivo != "INATIVO"
            );
        });
    },

    naoPossuiBens() {
      //    this.registro.tipoDeclaracao = {name: 'Não Possui Bens', code: 1}
      this.registro.tipoDeclaracao = "BRANCO";
    },

    declaracaoForm() {
      //    this.registro.tipoDeclaracao = {name: 'Formulário de Cadastro', code: 2}
      this.registro.tipoDeclaracao = "FORMULARIO";
    },

    declaracaoArqFederal() {
      //    this.registro.tipoDeclaracao = {name: 'Imposto de Renda Receita Feferal', code: 3}
      this.registro.tipoDeclaracao = "ARQUIVO";
    },

    paginaSelecionada(nomePagina) {
      return this.$routeName == nomePagina;
    },
    closeModal() {
      this.displayModal = false;
      this.$router.push({ path: `/${process.env.VUE_APP_BASE_URL}` });
    },
    protocolo(parms) {
      // if(this.registro.tipoDeclaracao == 'ARQUIVO'){
      //     this.TextoFinalizacao= 'Declaração enviada com sucesso'
      // }else{
      //     this.TextoFinalizacao= 'Declaração finalizada com sucesso'
      // }

      this.TextoFinalizacao = "Declaração enviada com sucesso";
      this.numProcotolo = parms.data.numrProtocolo;
      this.displayModal = true;
    },
    atualizarParmArq(parms) {
      this.parmForm.tipoDeclaracao = "ARQUIVO";
      if (parms.mod == "UPD") {
        this.parmForm.arquivosDeclaracao = this.parmForm.arquivosDeclaracao.map(
          (item) => {
            if (
              item.arquivo.idenArquivo ==
              parms.arquivosDeclaracao.arquivo.idenArquivo
            ) {
              return parms.arquivosDeclaracao;
            }
            return item;
          }
        );
      } else {
        this.parmForm.arquivosDeclaracao.push(parms.arquivo);
      }
    },
    isPermitiEditar(data) {
      if (data) {
        if (data.parametroExercicio) {
          let today = new Date();
          let dataFimEnvioDate = new Date();
          let regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/;
          let match = regex.exec(data.parametroExercicio.dataFimEnvio);      
          if(match){
            let [, day, month, year, hours, minutes, seconds] = match;
            dataFimEnvioDate = new Date(year, month - 1, day, hours, minutes, seconds);
            // console.log(today <= dataFimEnvioDate)    
            let validacaoDataFimEnvio = today <= dataFimEnvioDate;
            let validacaoAnoExercicio =
              data.parametroExercicio.anoExercicio == today.getFullYear();
            this.isPermitir = validacaoDataFimEnvio && validacaoAnoExercicio;
          }
        }
      }
    },
    
    excluirDeclaracao() {
      if (this.isPermitir) {
        this.$http
          .put(
            `${baseApiUrl}/pessoaexercicios/desativar/${this.parmForm.idenPessoaExercicio}/${this.idenContaAcesso}`
          )
          .then((res) => {
            printToast({
              severity: "success",
              summary: "Declaração Excluída",
              detail: res.data,
            });
            this.dialogConfirmacaoExclusao = false;

            setTimeout(() => {
              this.$router.push({ path: `/${process.env.VUE_APP_BASE_URL}` });
            }, 500);
          });
      }
    },
  },

  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>
.font-style {
  font-family: Verdana, sans-serif;
  text-align: center;
}

.btn-fc-white {
  background-image: url(../../../src/assets/icons/btn-fc-white.png);
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 20px;
}

.btn-fc-black {
  background-image: url(../../../src/assets/icons/btn-fc-black.png);
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 20px;
}
.btn-fc-black:hover {
  background-image: url(../../../src/assets/icons/btn-fc-white.png);
}

.btn-npb-white {
  background-image: url(../../../src/assets/icons/btn-npb-white.png);
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 20px;
}

.btn-npb-black {
  background-image: url(../../../src/assets/icons/btn-npb-black.png);
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 20px;
}

.btn-npb-black:hover {
  background-image: url(../../../src/assets/icons/btn-npb-white.png);
}

.btn-ir-white {
  background-image: url(../../../src/assets/icons/btn-ir-white.png);
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 20px;
}

.btn-ir-black {
  background-image: url(../../../src/assets/icons/btn-ir-black.png);
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 20px;
}

.btn-ir-black:hover {
  background-image: url(../../../src/assets/icons/btn-ir-white.png);
}

.button {
  align-items: center;
  background-color: #c8cacf;
  margin: 0.714rem 0.714rem;
  padding-left: 0.714rem;
  width: 20rem;
  height: 3.5rem;
  border-radius: 0.714rem;
  font-size: 1.2rem;
  font-weight: bold;
}

.button > span {
  margin-left: 20px;
}

.button:hover {
  background-color: #005494;
  color: white;
  align-content: center;
}

.buttonSelected {
  background-color: #005494;
  color: white;
}

.avisos {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(231 232 125 / 84%); /* Red */
  color: #000000;
  border-radius: 12px;
  font-size: 1.142rem;
  margin-bottom: 1vw;
  margin-top: 1vw;
}

.avisos p {
  margin-left: 0.7rem;
}

.passosSeguir {
  list-style-type: decimal-leading-zero;
  margin-left: 3vw;
}
.texto-centro {
  text-align: center;
}

@media screen and (max-width: 40em) {
  .passosSeguir {
    margin-left: 9vw;
    text-align: justify;
  }
}

@media screen and (min-width: 40em) and (max-width: 70rem) {
  .tipo-declaracao-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
}

.tipo-declaracao-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.nao-possui-bens-container {
  margin: auto auto;
}

.texto-centro > span {
  font-weight: 600;
}

.dialog-protocolo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 1vw;
}

.declaracaoBensContainer {
  display: flex;
  flex-direction: column;
}
</style>